export default __webpack_public_path__ + "static/media/Magnetism_09.ffd3959d.png";